<template>
  <div class="layout-page">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">{{name}}</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <div id="scroll-div-recommend" class="aui-scrollView no-foot">
      <swiper v-if="adList.length > 0" :ad-list="adList"></swiper>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getBooks"
      >
       <books-large :show-title="false" :books="list"></books-large>
      </van-list>
    </div>
  </div>
</template>

<script>
import Swiper from '@/components/share/swiper'
// import BooksSmall from '@/components/share/books-small'
import BooksLarge from '@/components/share/books-large'

import swiperService from '../../../services/swiperService'
import listService from '../../../services/listService'

export default {
  name: 'recommend',
  data () {
    return {
      componentName: '',
      adList: [],
      loading: false,
      finished: false,
      finishedText: '',
      list: [],
      currentPage: 1,
      name: '',
      type: ''

    }
  },
  methods: {
    getBooks () {
      const { finished, currentPage, list, type } = this
      if (finished) return
      listService.getMoreList(currentPage, type).then(res => {
        const resData = res.data
        const bookList = resData.bookList || []
        this.loading = false
        this.list = list.concat(bookList)
        if (currentPage >= resData.totalPage || bookList.length === 0) {
          this.finished = true
          if (this.list.length > 6) {
            this.finishedText = '没有更多了'
          } else {
            this.finishedText = ''
          }
        } else {
          this.currentPage++
        }
      })
    },
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    }
  },
  components: {
    swiper: Swiper,
    'books-large': BooksLarge
  },
  mounted () {
    this.componentName = this.$route.name
    const query = this.$route.query
    this.type = query.type
    this.name = query.name
    if (!query.type) {
      this.$router.push('/home')
      return
    }
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-recommend')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 5)
    } else {
      this.adList = swiperService.getAdList()
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-recommend')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>
</style>
